import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { t } from 'i18next';

interface DeleteModalProps {
  showAprove: boolean;
  setShowAprove: any;
  sendToApprove: any;
  setQuestion: string;
}

const ApproveModal: React.FC<DeleteModalProps> = ({ showAprove, setShowAprove, sendToApprove, setQuestion }) => {
  const handleClose = () => setShowAprove(false);

  return (
    <Dialog
      open={showAprove}
      onClose={handleClose}
      PaperProps={{
        style: {
          background: 'var(--bg-form)',
          borderRadius: 10,
          boxShadow: '0 8px 40px rgba(0,0,0,.18)',
          border: '1px solid var(--border-input)',
          minWidth: 320,
          maxWidth: 400,
        },
      }}
    >
      <DialogContent style={{ padding: '24px 24px 20px' }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--text-color)', textAlign: 'center', marginBottom: 20, lineHeight: 1.5 }}>
          {t(setQuestion)}
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button
            type="button"
            onClick={() => { sendToApprove(); handleClose(); }}
            style={{ flex: 1, height: 36, borderRadius: 8, border: 'none', background: 'var(--btn-user-btn)', color: 'var(--text-color)', fontSize: 13, fontWeight: 700, cursor: 'pointer', transition: 'background .15s' }}
            onMouseEnter={e => (e.currentTarget.style.background = 'var(--btn-user-hover)')}
            onMouseLeave={e => (e.currentTarget.style.background = 'var(--btn-user-btn)')}
          >
            {t('Yes')}
          </button>
          <button
            type="button"
            onClick={handleClose}
            style={{ flex: 1, height: 36, borderRadius: 8, border: '1px solid var(--border-input)', background: 'var(--btn-user-form)', color: 'var(--text-color)', fontSize: 13, fontWeight: 700, cursor: 'pointer', transition: 'background .15s' }}
            onMouseEnter={e => (e.currentTarget.style.background = 'var(--btn-user-hover)')}
            onMouseLeave={e => (e.currentTarget.style.background = 'var(--btn-user-form)')}
          >
            {t('No')}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ApproveModal;
